import { API_URL } from '../api';

let inFlightPromise = null;
let inFlightAt = 0;
const DEDUP_WINDOW_MS = 10_000;

/**
 * En GET av navigeringsinställningarna delas av alla hooks (tema, favoriter,
 * senaste, hopfällda sektioner) i 10 s. Ett misslyckat svar (t.ex. 401 före
 * inloggning) cachas INTE: annars hade hookarna som monteras direkt efter
 * inloggningen fått null, tolkat det som "inget sparat" och skrivit över
 * serverns värden med webbläsarens (A11-uppföljning, 2026-10-07).
 */
export function fetchNavigationPreferencesOnce() {
  const now = Date.now();
  if (inFlightPromise && now - inFlightAt < DEDUP_WINDOW_MS) {
    return inFlightPromise;
  }
  inFlightAt = now;
  const promise = (async () => {
    try {
      const res = await fetch(`${API_URL}/users/me/navigation-preferences`, {
        credentials: 'include',
      });
      if (!res.ok) return null;
      return await res.json();
    } catch {
      return null;
    }
  })();
  inFlightPromise = promise;
  promise.then((data) => {
    if (data === null && inFlightPromise === promise) {
      inFlightPromise = null;
      inFlightAt = 0;
    }
  });
  return promise;
}

/** Stabil nyckel för att avgöra om ett värde redan är sparat på servern. */
export function navigationPreferencesKey(value) {
  try {
    return JSON.stringify(value ?? null);
  } catch {
    return '';
  }
}

export function invalidateNavigationPreferencesCache() {
  inFlightPromise = null;
  inFlightAt = 0;
}
